// extracted by mini-css-extract-plugin
export var container = "_6l-0";
export var error = "_6l-9";
export var label = "_6l-5";
export var light = "_6l-6";
export var md = "_6l-3";
export var sm = "_6l-2";
export var thin = "_6l-8";
export var thinBold = "_6l-7";
export var vertical = "_6l-4";
export var xs = "_6l-1";